import React from 'react';
import DepartmentPaymentRequests from '../../components/DepartmentPaymentRequests';

const ExportsPaymentRequests = () => {
  return <DepartmentPaymentRequests department="EXPORTS" departmentLabel="Exports Dept" />;
};

export default ExportsPaymentRequests;
